import React from "react";

// Used to populate aloglia index field when sending events to algolia Analytics, and pass down adoebe analytics events
export const IndexContext = React.createContext({});
export const IndexContextProvider = ({
  index,
  analyticsEvents,
  algoliaClient,
  environment,
  suggestedSearch,
  setSuggestedSearch,
  suggestedSearchContext,
  setSuggestedSearchContext,
  children,
}) => (
  <IndexContext.Provider
    value={{
      index,
      analyticsEvents,
      algoliaClient,
      suggestedSearch,
      environment,
      setSuggestedSearch,
      suggestedSearchContext,
      setSuggestedSearchContext,
    }}
  >
    {children}
  </IndexContext.Provider>
);
